"use client";

import TypewriterText from "@/components/TypewriterText";
import { HOMEPAGE_COPY } from "@/lib/homepage/copy";
import type { HomepageLayoutVariant } from "@/lib/homepage/layoutVariant";

type HomepageHeroProps = {
  variant?: HomepageLayoutVariant;
};

export default function HomepageHero({ variant = "full" }: HomepageHeroProps) {
  const { prefix, words, staticWord, suffix, subline } = HOMEPAGE_COPY.hero;

  if (variant === "compact") {
    return (
      <section className="w-full rounded-sio-lg bg-sio-hero border border-border/60 shadow-sio-card">
        <div className="container mx-auto px-4 py-6 md:py-8">
          <h1 className="text-xl md:text-2xl font-bold text-center">
            {prefix} {staticWord} {suffix}
          </h1>
        </div>
      </section>
    );
  }

  return (
    <section className="w-full rounded-sio-lg bg-sio-hero border border-border/60 shadow-sio-card">
      <div className="container mx-auto px-4 pt-10 pb-6 md:py-16 md:pb-8">
        <div className="flex flex-col items-center justify-center space-y-4">
          <TypewriterText
            prefix={prefix}
            words={words}
            suffix={suffix}
            staticWord={staticWord}
          />
          <p className="text-base md:text-lg text-text-light text-center max-w-2xl leading-relaxed">
            {subline}
          </p>
        </div>
      </div>
    </section>
  );
}
